import React from 'react';
import { Database } from 'lucide-react';
import TemplateDBPanel from '../components/TemplateDBPanel';

/**
 * Template DB Setup — standalone sidebar page.
 * Manages per-industry default templateDB + Industry × Tier overrides.
 * Resolution order at sign-up time:
 *   1. Industry × Tier override  (WebApp.UAMS_IndustryTemplateDB)
 *   2. Industry default           (tbl_industry_master.TemplateDB)
 *   3. System fallback            ('RC26ERP_DEV')
 */
export default function TemplateDBSetupPage() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <Database size={16} color="var(--brand-blue, #3b82f6)" />
        <span style={{ fontSize: 13, fontWeight: 800, color: 'var(--text-primary)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
          Template DB Setup
        </span>
        <span style={{ fontSize: 11, color: 'var(--text-muted)', fontFamily: 'monospace' }}>
          Industry × Tier overrides · provisioning resolution
        </span>
      </div>
      <TemplateDBPanel standalone />
    </div>
  );
}
